import {Component, OnInit} from '@angular/core';
import {UserModel} from "../../../../models/user.model";
import {AuthService} from "../../../../services/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UsersService} from "../../../../services/users/users.service";
import {ShipmentService} from "../../../../open-api-generated/services/shipment.service";
import {UserRole} from "../../../../enums/user-role";
import {environment} from "../../../../../environments/environment";
import {Country} from "../../../../open-api-generated/models/country";
import {Shipment} from "../../../../open-api-generated/models/shipment";
import {ClientDeliveryService} from "../../../../enums/client-delivery-service";
import {ParcelsService} from "../../../../services/parcels/parcels.service";
import {ParcelService} from "../../../../services/parcel/parcel.service";
import {ToastsService} from "../../../../services/toasts.service";

declare var UIkit: any;

@Component({
  selector: 'app-shipment',
  templateUrl: './shipment.component.html',
  styleUrls: ['./shipment.component.scss']
})
export class ShipmentComponent implements OnInit {
  internalNumber: string = null;

  context: string = null;

  userModel: UserModel = new UserModel();

  activeCardName = 'info';

  shipment: Shipment = null;

  apiUrl: string = null;

  activeParcelCardName = null;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private shipmentService: ShipmentService,
    private parcelsService: ParcelsService,
    private parcelService: ParcelService,
    private toastsService: ToastsService,
  ) {
    this.apiUrl = environment.api;
    this.shipment = {
      client_id: null,
      sender: {
        name: null,
        private_person: true,
        contact_name: null,
        email: null,
        address: {
          locality: {
            id: null,
            name: null,
          },
          postal_code: null,
          details: null,
        },
        country: {
          id: null,
          name: null,
          iso_code: null,
        },
        locker: {
          id: null,
          name: null,
        },
        phone: {
          prefix: null,
          number: null
        }
      },
      recipient: {
        name: null,
        private_person: true,
        contact_name: null,
        email: null,
        address: {
          locality: {
            id: null,
            name: null,
          },
          postal_code: null,
          details: null,
        },
        country: {
          id: null,
          name: null,
          iso_code: null,
        },
        locker: {
          id: null,
          name: null,
        },
        phone: {
          prefix: null,
          number: null
        }
      },
      internal_info: {
        creator: 'app_v2',
        is_emag: false,
        is_return: false,
      },
      content: {
        cash_on_delivery_value: 0,
        currency: null,
        declared_content: null,
        declared_value: 0,
      },
      additional_data: {
        note: null,
        first_reference_number: null,
        second_reference_number: null,
      },
      waybill: null,
      external_couriers: null,
      parcels: [],
      delivery_service: ClientDeliveryService.HomeDelivery,
    }
  }

  ngOnInit(): void {
    this.internalNumber = this.route.snapshot.paramMap.get('internalNumber');

    this.authService.whoami().subscribe(
      (userModel: UserModel) => {
        this.userModel = userModel;
      }
    );

    if (null !== this.internalNumber) {
      this.shipmentService.appV2ShipmentGet({internalNumber: this.internalNumber}).subscribe(
        (shipmentResponse: any) => {
          this.shipment = shipmentResponse.shipment;
          this.context = shipmentResponse.context;
          if (this.shipment.parcels.length > 1) {
            for (let parcel of this.shipment.parcels) {
              if (this.internalNumber === parcel.waybill.internal) {
                this.activeParcelCardName = this.internalNumber;
              }
            }

            this.internalNumber = this.shipment.waybill.internal;
          }
        },
        (error: any) => {
          if (404 === error.status) {
            this.toastsService.showMessage('Taka przesylka nie istnieje', 'e');
          }
        }
      );
    }
  }

  activeCardChanged(cardName: string): void {
    this.activeCardName = cardName;
  }

  country(): Country {
    if (this.shipment.internal_info.is_return) {
      return this.shipment.sender.country;
    }

    return this.shipment.recipient.country;
  }

  flagUrl(): string {
    if (
      'parcel' === this.context
    ) {
      return this.apiUrl + 'app/v1/asset/icon/danger';
    }

    return this.apiUrl + 'app/v1/asset/flag/' + this.country()?.iso_code;
  }

  countryName(): string {
    if (
      'parcel' === this.context
    ) {
      return '';
    }

    return this.country()?.name;
  }

  isAdoptUnprocessableParcelToClientAllowed(): boolean {
    if (
      UserRole.admin !== this.userModel.role
      || 'shipment' === this.context
      || null === this.findBufferNumber()
    ) {
      return false;
    }

    return false === this.shipment.internal_info.processable;
  }

  openAdoptUnprocessableParcelToClientModal(): void {
    UIkit.modal('#adoptUnprocessableParcelToClientModal').show();
  }

  isAdoptBufferParcelToClientAllowed(): boolean {
    if (
      UserRole.admin !== this.userModel.role
      || 'shipment' === this.context
      || null === this.findBufferNumber()
    ) {
      return false;
    }

    return this.shipment.internal_info.processable;
  }

  openAdoptBufferParcelToClientModal(): void {
    UIkit.modal('#adoptBufferParcelToClientModal').show();
  }

  isReturnStickerDownloadAllowed(): boolean {
    if (
      UserRole.admin !== this.userModel.role
      || 'shipment' === this.context
      || null === this.findDuplicatedNumber()
    ) {
      return false;
    }

    return true;
  }

  openReturnSticker(): void {
    this.parcelsService.getPublicFileToken().subscribe(
      (tokenResponse: any) => {
        window.open(
          this.apiUrl
          + 'app/v1/parcel/' + this.internalNumber + '/generate-return-sticker?_public_token='
          + tokenResponse.public_token
        );
      }
    );
  }

  isDownloadLabelAllowed(): boolean {
    if (
      'parcel' === this.context
      || 'init_scan' === this.shipment.internal_info.creator
    ) {
      return false;
    }

    return true;
  }

  openDownloadLabelModal(): void {
    UIkit.modal('#downloadShipmentLabelsModal').show();
  }

  isSetNewBufferNumberAllowed(): boolean {
    if ('shipment' === this.context
        || null === this.findDuplicatedNumber()
    ) {
      return false;
    }

    return true;
  }

  openSetNewBufferNumberModal(): void {
    UIkit.modal('#set-new-buffer-number-modal').show();
  }

  openByNewNumber(): void {
    setTimeout(
      (): void => {
        this.parcelService.findByIdentifier(this.shipment.internal_info.parcel_id, ['internal_number']).subscribe(
          (internalNumberResponse: any) => {
            window.location.href = '/shipment/' + internalNumberResponse.internal_number;
          });
      }, 10
    );
  }

  isMarkAsRemovedAllowed(): boolean {
    if (UserRole.admin === this.userModel.role) {
      return true;
    }

    if (
      UserRole.warehouse_worker === this.userModel.role
      || 'parcel' === this.context
      || 'init_scan' === this.shipment.internal_info.creator
    ) {
      return false;
    }

    for (let parcel of this.shipment.parcels) {
      if (this.shipment.internal_info.is_return) {
        if (null !== parcel.timestamps.return_warehouse_received_at) {
          return false;
        }
      }
      else {
        if (null !== parcel.timestamps.shipping_warehouse_received_at) {
          return false;
        }
      }
    }

    return true;
  }

 async openConfirmMarkAsRemovedModal() {
    const promised: boolean = await this.toastsService.showConfirmModal();
    if (!promised) {
      return;
    }

    this.shipmentService.appV2ShipmentDelete({
      body: {
        waybill: this.internalNumber,
      },
    }).subscribe(
      (): void => {
        this.toastsService.showMessage('Przesyłka została oznaczona jako usunięte!', 's');
        this.router.navigateByUrl('parcel-list');
      },
      (): void => {
        this.toastsService.showMessage('Nie można oznaczyć przesyłki została oznaczona jako usunięta!', 'e');
      }
    );

  }

  isCopyTrackingLinkAllowed(): boolean {
    return true;
  }

  copyTrackingLink(): void {
    navigator.clipboard.writeText(window.location.protocol + '//' + window.location.host + `/tracking/${this.internalNumber}`);
    this.toastsService.showMessage('link_was_copied', 's');
  }

  goBackToList(): void {
    this.router.navigateByUrl('/dashboard');
  }

  private findBufferNumber(): string {
    for (let parcel of this.shipment.parcels) {
      return parcel.waybill.external_buffer;
    }
  }

  private findDuplicatedNumber(): string {
    for (let parcel of this.shipment.parcels) {
      return parcel.waybill.external_duplicated;
    }
  }

  protected readonly UserRole: typeof UserRole = UserRole;
}
